<nz-form-control>
  <div class="cell-attachments">

    <!-- Thumbnail area -->
    <div class="thumb">
      <!-- Image thumbnail if any image exists -->
      <ng-container *ngIf="images.length > 0; else noImages">
        <img
          class="thumb-img"
          [src]="images[0].path | productImageUrl"
          alt="image"
        />
      </ng-container>

      <!-- No image: show placeholder -->
      <ng-template #noImages>
        <div class="thumb-empty">
          <i nz-icon nzType="picture" nzTheme="outline"></i>
        </div>
      </ng-template>

      <!-- count badge for total attachments -->
      <div class="badge" *ngIf="items.length > 1">{{ items.length }}</div>
    </div>

    <!-- Actions row (clean, no overlay) -->
    <div class="actions">
      <!-- Images action -->
      <button
        *ngIf="images.length > 0"
        nz-button
        nzSize="small"
        nzType="default"
        (click)="previewImageGallery()"
        title="Preview images"
      >
        <i nz-icon nzType="eye" nzTheme="outline"></i>
      </button>

      <!-- Files dropdown action -->
      <button
        *ngIf="files.length > 0"
        nz-button
        nzSize="small"
        nzType="default"
        nz-dropdown
        [nzDropdownMenu]="fileMenu"
        nzTrigger="click"
        (click)="$event.stopPropagation()"
        title="Files"
      >
        <i nz-icon nzType="paper-clip" nzTheme="outline"></i>
        <span class="files-count">{{ files.length }}</span>
      </button>

      <nz-dropdown-menu #fileMenu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item *ngFor="let f of files" (click)="previewOrDownloadFile(f.path)">
            <i nz-icon nzType="file" nzTheme="outline"></i>
            <span class="file-item-name">{{ f.name }}</span>
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>

  </div>
</nz-form-control>
